import { render } from "./Divider.vue?vue&type=template&id=cd9c1f08&scoped=true"
const script = {}

import "./Divider.vue?vue&type=style&index=0&id=cd9c1f08&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd9c1f08"]])

export default __exports__